export const publicProfileConstants = {
  // hms client token
  GET_USER_PUBLIC_PROFILE_DATA_ACTION_REQUEST:
    "GET_USER_PUBLIC_PROFILE_DATA_ACTION_REQUEST",
  GET_USER_PUBLIC_PROFILE_DATA_ACTION_SUCCESS:
    "GET_USER_PUBLIC_PROFILE_DATA_ACTION_SUCCESS",
  GET_USER_PUBLIC_PROFILE_DATA_ACTION_FAILURE:
    "GET_USER_PUBLIC_PROFILE_DATA_ACTION_FAILURE",

  //get all public event links
  GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_REQUEST:
    "GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_REQUEST",
  GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_SUCCESS:
    "GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_SUCCESS",
  GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_FAILURE:
    "GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_FAILURE",

  //get all public assessment kits
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_REQUEST:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_REQUEST",
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_SUCCESS:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_SUCCESS",
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_FAILURE:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_FAILURE",

  //get all public videos links
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_REQUEST:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_REQUEST",
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_SUCCESS:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_SUCCESS",
  GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_FAILURE:
    "GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_FAILURE",

  // hms client token
  GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_REQUEST:
    "GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_REQUEST",
  GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_SUCCESS:
    "GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_SUCCESS",
  GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_FAILURE:
    "GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_FAILURE",
};
